import React from "react";

function HotelInfo({ data }) {
  return (
    <div id="presentation" className="mt-10">

      <div className="
        grid md:grid-cols-2 gap-10 items-start
      ">

        {/* LEFT - INFOS */}
        <div className="text-center md:!text-left">

          <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">
            Hôtel {data.name}
          </h1>

          <p className="text-gray-500 mt-1">
            {data.adress}, {data.city}
          </p>

          <p className="text-gray-600 mt-6 leading-relaxed">
            {data.desc}
          </p>

        </div>

        {/* RIGHT - MAP */}
        <div className="w-full h-[260px] rounded-2xl overflow-hidden shadow-sm">

          <iframe
            title="map"
            className="w-full h-full border-0"
            loading="lazy"
            src={`https://maps.google.com/maps?q=${data.adress}${data.city}${data.name}&output=embed`}
          />

        </div>

      </div>
      <div className="mt-12 flex items-center">
  <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
</div>

    </div>
  );
}

export default HotelInfo;